import React, { createContext, useState } from 'react';
export const GlobalContext = createContext();
export const GlobalProvider = ({ children }) => {
    const [gbStPartyInfo, setGbStPartyInfo] = useState(null);
    const [gbStItemInfo,setGbStItemInfo]=useState(null);

    const setPartyInfo = (listPartyInfo) => {
        setGbStPartyInfo(listPartyInfo);
      }

      const setItemInfo=(listItemInfo)=>{
        setGbStItemInfo(listItemInfo);
      }

      return (
        <GlobalContext.Provider value={{ 
         
        gbStPartyInfo, setPartyInfo, 
        gbStItemInfo, setItemInfo
         }}>
          {children}
        </GlobalContext.Provider>
      );
}